'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userBasicDetails = require('./user-basic-details.html');

var _userBasicDetails2 = _interopRequireDefault(_userBasicDetails);

var _userBasicDetails3 = require('./user-basic-details.controller');

var _userBasicDetails4 = _interopRequireDefault(_userBasicDetails3);

require('./user-basic-details.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userBasicDetailsComponent = {
  restrict: 'E',
  bindings: {
    user: '='
  },
  template: _userBasicDetails2.default,
  controller: _userBasicDetails4.default,
  controllerAs: 'vm'
};

exports.default = userBasicDetailsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-basic-details/user-basic-details.component.js
 **/